import { queryOptions } from '@tanstack/react-query';
import { getAuthUser } from '~/services/api/fetchers/auth-user.api';
import { AuthUserModel } from '~/shared/models/auth-user/AuthUserModel';

export const authUserQuery = queryOptions({
  queryKey: ['authUser'],
  queryFn: async () => {
    const authUser = await getAuthUser();
    if (!authUser) {
      return null;
    }
    return new AuthUserModel(authUser);
  },
});
